import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'swiper/swiper.min.css';
import { useMemo, useState } from 'react';
import { useMobile } from '../../common/hooks/use-mobile';
import { transformInterval, transformPageMargins } from '../../common/utils';
import { classNames } from '../../common/utils/classnames';
import { Image } from '../../common/components/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { chunk, get, isEmpty } from 'lodash-es';
import { WithImageGoods } from './with-image-goods';
import { AspectRatioView } from '../../common/components/aspect-ratio-view';
import { useDesignContext } from '../../design-provider';
export var WithImage = function WithImage(props) {
  var _a;
  var leftAd = props.leftAd,
    dataset = props.dataset,
    goodsGap = props.goodsGap,
    pagePadding = props.pagePadding;
  var _useState = useState(0),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  var linkPath = designOnLink((_a = leftAd.target) !== null && _a !== void 0 ? _a : {});
  var displayGoodsList = getDataList();
  var displayGoodsListChunk = useMemo(function () {
    if (mobile) {
      return chunk(displayGoodsList, 2);
    } else {
      return chunk(displayGoodsList, 4);
    }
  }, [mobile]);
  function getDataList() {
    if (isEmpty(get(dataset, 'products.data', []))) {
      return (get(dataset, 'data', []) || []).slice(0, 8);
    } else {
      return (get(dataset, 'products.data', []) || []).slice(0, 8);
    }
  }
  return _jsx("div", Object.assign({
    className: 'w-full h-full bg-white'
  }, {
    children: _jsx("div", Object.assign({
      className: 'container'
    }, {
      children: _jsx("div", Object.assign({
        className: 'w-full',
        style: {
          paddingLeft: transformPageMargins(pagePadding, mobile),
          paddingRight: transformPageMargins(pagePadding, mobile)
        }
      }, {
        children: _jsxs("div", Object.assign({
          className: classNames('grid w-full border border-ahaa-black-5', 'gap-2 grid-cols-2', 'cq-pc:grid-cols-3 cq-pc:gap-3')
        }, {
          children: [_jsx(AspectRatioView, Object.assign({
            className: 'col-span-1 !h-full',
            aspectRatio: '2/1'
          }, {
            children: _jsx("a", Object.assign({
              className: 'block w-full h-full',
              href: linkPath
            }, {
              children: _jsx(Image, {
                className: 'w-full h-full cursor-pointer',
                src: leftAd.image
              })
            }))
          })), _jsxs(Swiper, Object.assign({
            className: classNames('col-span-1 pb-6.5 w-full h-full', 'cp-pc:grid cq-pc:col-span-2'),
            onActiveIndexChange: function onActiveIndexChange(s) {
              return setActiveIndex(s.activeIndex);
            }
          }, {
            children: [displayGoodsListChunk.map(function (displayGoodsList, index) {
              return _jsx(SwiperSlide, Object.assign({
                className: classNames('grid w-full h-full grid-rows-2 !pl-0', '!p-3', 'cq-pc:grid-cols-2 cq-pc:!p-6'),
                style: {
                  gap: transformInterval(goodsGap, mobile, 'proudcCard')
                }
              }, {
                children: displayGoodsList.map(function (item) {
                  return _jsx(WithImageGoods, {
                    goods: item,
                    className: classNames('row-span-1', 'cq-pc:col-span-1')
                  }, item.csku);
                })
              }), index);
            }), _jsx("div", Object.assign({
              className: 'absolute left-0 bottom-0 flex items-center justify-center w-full h-6.5 z-10'
            }, {
              children: displayGoodsListChunk.map(function (_, index) {
                return _jsx("div", {
                  className: classNames('ml-1.5 w-[3px] h-[3px] bg-[rgba(0,0,0,0.1)] first:ml-0', {
                    'bg-[rgba(0,0,0,0.3)]': index === activeIndex
                  })
                }, index);
              })
            }))]
          }))]
        }))
      }))
    }))
  }));
};